/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import {
  Button,
  Spinner,
  UncontrolledTooltip,
  Modal,
  Pagination,
  PaginationItem,
  PaginationLink,
  Label,
} from "reactstrap";
import i18n from "../../i18n";

import { Link } from "react-router-dom";

import { isFunction } from "../CustomMethods/customMethods";

export const setClassName = (errors, classname) => {
  return errors ? "av-invalid is-invalid " + classname : classname;
};

export const selectStyle = {
  option: (styles, { data, isDisabled }) => {
    return {
      ...styles,
      color: isDisabled ? "#495057" : data.color,
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
};

export const getOptions = (data, loading) => {
  let options = [];

  if (data?.length > 0) {
    data.map((op, key) =>
      options.push({
        key: key,
        value: op?.id,
        label: i18n.t(op?.name),
        isDisabled: op?.isDisabled,
      })
    );
  } else {
    if (loading) {
      options.push({
        value: "loading",
        label: i18n.t("Loading..."),
        isDisabled: true,
      });
    } else {
      options.push({
        value: "empty",
        label: i18n.t("No matching records found"),
        isDisabled: true,
      });
    }
  }
  return options;
};

export const getPages = (total, qtd) => {
  let maxPage = Math.ceil(total / qtd) || 0;
  let paging = [...Array(maxPage).keys()].map((i) => i + 1);
  return paging;
};

export const renderSpinner = () => (
  <React.Fragment>
    <tr>
      <td colSpan="20" align="center">
        <Spinner
          size="sm"
          animation="border"
          style={{
            marginTop: "40px",
            height: "50px",
            width: "50px",
          }}
        />
      </td>
    </tr>
  </React.Fragment>
);

export const renderClickSearch = (t) => (
  <React.Fragment>
    <tr>
      <td colSpan="20" align="center">
        {t("Click search to show the records")}
      </td>
    </tr>
  </React.Fragment>
);

export const renderNotFound = (t) => (
  <tr>
    <td colSpan="20" align="center">
      {t("No matching records found")}
    </td>
  </tr>
);

export const renderButtons = (
  enableSubmit,
  loading,
  mainPath,
  handleCancel,
  t
) => (
  <React.Fragment>
    <Button
      type="submit"
      color="primary"
      className="mr-1 waves-effect waves-light"
      style={{
        minWidth: "100px",
        cursor: enableSubmit ? "pointer" : "no-drop",
      }}
      disabled={!enableSubmit}
    >
      {loading ? (
        <Spinner
          size="sm"
          animation="border"
          style={{
            height: "19px",
            width: "19px",
          }}
        />
      ) : (
        t("Confirm")
      )}
    </Button>
    <Link to={mainPath}>
      <Button
        type="button"
        color="secondary"
        className="waves-effect btn-dark"
        onClick={() => isFunction(handleCancel) && handleCancel()}
      >
        {t("Cancel")}
      </Button>
    </Link>
  </React.Fragment>
);

export const renderAction = (item, key, path, toggle, setData, t) => (
  <React.Fragment>
    <Link className="text-primary text-center px-1" to={`${path}/${item.id}`}>
      <i id={`edittooltip${key}`} className="mdi mdi-pencil" />
      <UncontrolledTooltip placement="auto" target={`edittooltip${key}`}>
        {t("Edit")}
      </UncontrolledTooltip>
    </Link>
    <div className="text-danger text-center px-1 pointer">
      <i
        id={`deletetooltip${key}`}
        className="mdi mdi-window-close"
        onClick={() => {
          isFunction(toggle) && toggle();
          isFunction(setData) && setData(item);
        }}
      />
      <UncontrolledTooltip placement="auto" target={`deletetooltip${key}`}>
        {t("Delete")}
      </UncontrolledTooltip>
    </div>
  </React.Fragment>
);

const renderPages = (array, active, handleThis) => {
  if (array?.length < 8) {
    return array?.map((value, key) => (
      <PaginationItem
        key={key}
        onClick={() => {
          isFunction(handleThis) && handleThis(value);
        }}
        active={active === value}
      >
        <PaginationLink className="d-inline">{value}</PaginationLink>
      </PaginationItem>
    ));
  } else {
    if (active < 5) {
      return array?.map((value, key) =>
        key === array?.length - 2 ? (
          <PaginationItem key={key}>
            <PaginationLink className="d-inline">{"..."}</PaginationLink>
          </PaginationItem>
        ) : (
          (key < 5 || key === array.length - 1) && (
            <PaginationItem
              key={key}
              onClick={() => {
                isFunction(handleThis) && handleThis(value);
              }}
              active={active === value}
            >
              <PaginationLink className="d-inline">{value}</PaginationLink>
            </PaginationItem>
          )
        )
      );
    }
    if (active > array?.length - 4) {
      return array?.map((value, key) =>
        key === 1 ? (
          <PaginationItem key={key}>
            <PaginationLink className="d-inline">{"..."}</PaginationLink>
          </PaginationItem>
        ) : (
          (key > array.length - 6 || key === 0) && (
            <PaginationItem
              key={key}
              onClick={() => {
                isFunction(handleThis) && handleThis(value);
              }}
              active={active === value}
            >
              <PaginationLink className="d-inline">{value}</PaginationLink>
            </PaginationItem>
          )
        )
      );
    }
    return array?.map((value, key) =>
      key === 1 || key === array?.length - 2 ? (
        <PaginationItem key={key}>
          <PaginationLink className="d-inline">{"..."}</PaginationLink>
        </PaginationItem>
      ) : (
        (key === active - 2 ||
          key === active - 1 ||
          key === active ||
          key === 0 ||
          key === array.length - 1) && (
          <PaginationItem
            key={key}
            onClick={() => {
              isFunction(handleThis) && handleThis(value);
            }}
            active={active === value}
          >
            <PaginationLink className="d-inline">{value}</PaginationLink>
          </PaginationItem>
        )
      )
    );
  }
};

export const renderQtdPerPage = (qtdDefault, handleQtdDefault, t) => (
  <div>
    <Label>{t("Number of records per page")}</Label>
    <input
      style={{ width: 50 }}
      type="number"
      className={"form-control"}
      placeholder={t("Nº")}
      onChange={(e) => {
        isFunction(handleQtdDefault) && handleQtdDefault(e.target.value);
      }}
      value={qtdDefault}
    />
  </div>
);

export const renderPagination = (
  page,
  pages,
  handlePrev,
  handleThis,
  handleNext
) => (
  <React.Fragment>
    {pages?.length > 1 && (
      <Pagination className="pagination pagination-rounded justify-content-end my-2 overflow-auto pt-2">
        <PaginationItem onClick={() => isFunction(handlePrev) && handlePrev()}>
          <PaginationLink previous />
        </PaginationItem>
        {renderPages(pages, page, handleThis)}
        <PaginationItem onClick={() => isFunction(handleNext) && handleNext()}>
          <PaginationLink next />
        </PaginationItem>
      </Pagination>
    )}
  </React.Fragment>
);

export const renderDeleteModal = (modal, data, loading, toggle, handle, t) => (
  <Modal isOpen={modal || loading}>
    <div className="modal-body font-size-18 text-center">
      {t("Do you want to delete")}
      <strong style={{ overflowWrap: "anywhere" }}> {data}</strong>?
    </div>
    <div className="modal-footer">
      <button
        type="button"
        onClick={toggle}
        className="btn btn-danger waves-effect"
        data-dismiss="modal"
      >
        {t("No")}
      </button>
      {loading ? (
        <button
          type="button"
          className="btn btn-secondary waves-effect waves-light"
          disabled
        >
          <Spinner size="sm" animation="border" />
        </button>
      ) : (
        <button
          type="button"
          className="btn btn-secondary waves-effect waves-light"
          onClick={() => {
            isFunction(toggle) && toggle();
            isFunction(handle) && handle();
          }}
        >
          {t("Yes")}
        </button>
      )}
    </div>
  </Modal>
);
